<template>
  <div class="print-me">
    <div id="poster-preview">
      <div class="poster-content">
        <b-row class="d-flex align-items-center justify-content-center print-logo pb-0">
          <b-navbar-brand href="#" class="text-center">
            SITEACCESS<span>pro</span>
          </b-navbar-brand>
        </b-row>
        <b-row class="qr-code">
          <b-col align-h="d-flex align-items-center justify-content-center">
            <qrcode-vue
              :value="qrLink"
              size="460"
              level="M"
              renderAs="svg"
              class="qr-code-svg m-3 align-self-center d-flex align-items-center justify-content-center"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3 class="poster-job text-center mb-4 mt-n2">{{ site.jobNumber }} - {{ site.name }}</h3>
          </b-col>
        </b-row>
      </div>
    </div>
    <div id="poster">
      <div id="poster-content" class="poster-content">
        <div class="background-svg">
          <SitePosterSvg />
        </div>
        <b-row class="d-flex align-items-center justify-content-center print-logo pb-0">
          <!-- <b-navbar-brand href="#" class="text-center">
            SITEACCESS<span>pro</span>
          </b-navbar-brand> -->
        </b-row>
        <div class="qr-code-container">
          <b-row class="qr-code">
            <b-col align-h="d-flex align-items-center justify-content-center">
              <qrcode-vue
              :value="qrLink"
              size="460"
              level="M"
              renderAs="svg"
              class="qr-code-svg m-3 align-self-center d-flex align-items-center justify-content-center"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h3 class="poster-job text-center mb-4 mt-n2">{{ site.jobNumber }} - {{ site.name }}</h3>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="instructions">
        <h1 id="instructions-title font-weight-bold" style="font-weight: 700">SIGN IN TO REVIEW SITE HAZARDS</h1>
        <img width="40%" :src="logo" />
      </div>
    </div>
    <div id="poster">
      <div class="poster-content">
        <b-row class="d-flex align-items-center justify-content-center print-logo pb-0">
          <b-navbar-brand href="#" class="text-center">
            SITEACCESS<span>pro</span>
          </b-navbar-brand>
        </b-row>
        <b-row class="qr-code">
          <b-col align-h="d-flex align-items-center justify-content-center">
            <qrcode-vue
              :value="qrLink"
              size="460"
              level="M"
              renderAs="svg"
              class="qr-code-svg m-3 align-self-center d-flex align-items-center justify-content-center"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3 class="poster-job text-center mb-4 mt-n2">{{ site.jobNumber }} - {{ site.name }}</h3>
          </b-col>
        </b-row>
      </div>
      <div class="instructions">
        <h1 id="instructions-title font-weight-bold" style="font-weight: 700">SIGN IN TO REVIEW SITE HAZARDS</h1>
        <img width="40%" :src="logo" />
      </div>
    </div>
    <b-container class="pb-5">
      <b-row>
        <b-col>
          <b-button @click="printPoster()" class="align-self-right btn-print">Print</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="print-note text-center"><small>For best results print in Chrome and enable background graphics in your print settings.</small></p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style lang="scss">
.bg-red {
  background-color: #ed2124;
}
</style>

<script>
import QrcodeVue from 'qrcode.vue';
import printJS from 'print-js';
// import SitePosterSvg from '../components/';
// import SitePosterSVG from './'
// import SitePosterSvg from './SitePosterSvg.'
import SitePosterSvg from './SitePosterSvgNew.vue';

export default {
  name: 'SitePoster',
  components: {
    SitePosterSvg,
    QrcodeVue,
  },
  props: {
    boundSite: {
      type: Object,
      default: () => null,
    },
    showQRCode: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    boundSite() {
      this.updateSite();
    },
  },
  data() {
    return {
      site: {},
      logo: require('@/assets/common/schick-logo.png'), // eslint-disable-line global-require
    };
  },
  computed: {
    qrLink() {
      return `${process.env.VUE_APP_BASE}/visitor-sign-in?siteId=${this.site.id}&siteLongId=${this.site.longid}`;
    },
  },
  mounted() {
    this.updateSite();
  },
  methods: {
    async updateSite() {
      if (!this.boundSite) return;
      this.site = this.boundSite;
    },
    printPoster() {
      const styles = [].slice.call(document.getElementsByTagName('style'));
      const stylesRaw = styles.reduce((accumulator, style) => {
        if (style.innerHTML.includes('#poster-content')) {
          accumulator = `${accumulator}\n${style.innerHTML.split('/* print-poster DO NOT REMOVE THIS COMMENT */')[1]}`; // eslint-disable-line no-param-reassign
        }
        return accumulator;
      }, '');

      const printStylesWithMargins = `
        ${stylesRaw}
        @page {
          margin: 0;
        }
      `;

      printJS({
        printable: 'poster-content',
        type: 'html',
        // style: stylesRaw,
        style: printStylesWithMargins,
        targetStyles: '*',
        maxWidth: '1240',
      });
    },
    // printPoster(areaName) {
    //   const newContent = document.getElementById(areaName).innerHTML;
    //   const actContent = document.body.innerHTML;
    //   document.body.innerHTML = newContent;
    //   window.print();
    //   document.body.innerHTML = actContent;
    // },
  },
};
</script>
